<div class="h-100 row justify-content-center align-items-center">
    <div class="login-size">
        <div class="position-relative">
            <div class="position-relative mask-clip">
                <div class="login-card" [ngClass]="{ 'background-banner': showLoginBanner()}">
                    <ng-content></ng-content>
                </div>
                <!-- design images -->
                <img class="bottom-border pe-none" src="assets/shapes/borders/MenuBorderShape.svg" alt="bottom-left-corner" />
                <img class="bottom-border mirrored pe-none" src="assets/shapes/borders/MenuBorderShape.svg" alt="bottom-right-corner" />
    
            </div>
            <!-- design images -->
            <img class="top-border pe-none" src="assets/shapes/borders/MenuBorderShape.svg" alt="top-left-corner" />
            <img class="top-border mirrored pe-none" src="assets/shapes/borders/MenuBorderShape.svg" alt="right-left-corner" />
        </div>
    </div>
</div>